/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Description_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Add notes about this record" |
*
* @param {Explorer_Info_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_description_placeholder = /** @type {((inputs?: Explorer_Info_Description_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Description_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Add notes about this record")
	if (locale === "de") return /** @type {LocalizedString} */ ("Add notes about this record")
	if (locale === "it") return /** @type {LocalizedString} */ ("Add notes about this record")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Add notes about this record")
	if (locale === "es") return /** @type {LocalizedString} */ ("Add notes about this record")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Add notes about this record")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Add notes about this record")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Add notes about this record")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Add notes about this record")
	return /** @type {LocalizedString} */ ("Add notes about this record")
});